import React, {ButtonHTMLAttributes} from 'react';
import styled from 'styled-components';
import {device} from 'styled/device';

export const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  background: white;
  color: #23262f;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 500;
  height: 50px;
  max-width: min-content;
  padding: 0 30px;
  border-radius: 25px;
  border: 2px solid #e6e8ec;
  cursor: pointer;
  transition: all 0.07s ease-in-out;

  &:hover {
    background: #353945;
    border: 2px solid #353945;
    color: #fcfcfd;
  }

  @media (max-width: ${device.mobileM}) {
    height: 42px;
    font-size: 20px;
    font-weight: 500;

    &:hover {
      font-weight: 500;
    }
  }
`;

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: React.ReactNode | string;
  icon?: React.ReactNode;
  title?: string;
};

const defaultProps: ButtonProps = {
  label: '',
  icon: null,
  title: undefined,
};

function WhiteButton({icon, label, disabled, className, title, ...props}: ButtonProps) {
  return (
    <StyledButton disabled={disabled} className={className} title={title} {...props}>
      {label}
    </StyledButton>
  );
}

WhiteButton.defaultProps = defaultProps;
export default WhiteButton;
